module.exports = __webpack_public_path__ + "static/img/qblueLogo.7a7dfc60.png";